import { deepCopy } from "@compass/core";
import { DataModel } from "generated/openApi";
import produce from "immer";
import { useState } from "react";

export const useInlineEditDataModel = <T extends DataModel>(props: {
  dataModel: T;
  setDataModel: (value: T) => void;
  cancelCreate?: () => void;
}) => {
  const [originalDataModel, setOriginalDataModel] = useState<T>();

  // an item's "touched" field must be set to true for backend to take effect, even if the dataModel is new (id === 0)
  const editing = props.dataModel.touched && !props.dataModel.deleted;
  const removing = props.dataModel.deleted;
  const canEdit = props.dataModel.id > 0 && !props.dataModel.touched && !props.dataModel.deleted;
  const canCancel = editing || props.dataModel.deleted;
  const canRemove = props.dataModel.id > 0 && !props.dataModel.touched && !props.dataModel.deleted;

  const edit = () => {
    props.setDataModel(
      produce(props.dataModel, (draft) => {
        draft.touched = true;
      })
    );

    setOriginalDataModel(deepCopy(props.dataModel)); // saved an original copy to be reverted back to
    // if (setCrudMode) setCrudMode("edit");
  };

  const cancel = () => {
    if (props.dataModel.id > 0) {
      if (props.dataModel.deleted)
        props.setDataModel?.(
          produce(props.dataModel, (draft) => {
            draft.deleted = false;
            draft.touched = false;
          })
        );
      else props.setDataModel?.(originalDataModel!);
    } else {
      props.cancelCreate?.();
    }
  };

  const remove = () => {
    props.setDataModel?.(
      produce(props.dataModel, (draft) => {
        draft.deleted = true;
        draft.touched = true;
      })
    );
  };

  return { canEdit, canCancel, canRemove, editing, removing, edit, remove, cancel };
};
